import {Component, OnInit} from '@angular/core';
import {AppService, AuthUser} from '../../utils/services/app.service';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.css']
})

export class MenuSidebarComponent implements OnInit {

  public authUser: AuthUser;

  constructor(public appService: AppService) {

  }

  ngOnInit() {
    this.authUser = this.appService.getAuthUser();
  }

  logout() {
    this.appService.logoutUser();
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/menu-sidebar/menu-sidebar.component.ts